export default "__VITE_ASSET__Do24P5Gk__"